import { BooleanField,  Datagrid, Loading, RaRecord, TextField, useListContext, useTranslate } from "react-admin";
import CoreDeleteButton from "../../../../shared/components/core/CoreDeleteButton";
import CoreEditButton from "../../../../shared/components/core/CoreEditButton";
import { SamplingLocation } from "../../../../shared/types/types";
import sacopModules from "../../../../shared/utilities/sacopModules";
import NoDataFound from "../../../../shared/components/noDataFound/NoDataFound";

interface MobileGridProps {
    data?: RaRecord[];
}

const MobileGrid = (props: MobileGridProps) => {

    const { data, isLoading } = useListContext<SamplingLocation>();
    if (isLoading || data?.length === 0) {
        if (data?.length === 0)
            return <NoDataFound />
        return <Loading />;
    }

    return (
        <Datagrid bulkActionButtons={false}>
            <TextField source="name" variant="body1" />
            <BooleanField source="active" />
            <CoreEditButton permission="BACKOFFICE_SAMPLING_LOCATION_U" actionModule={sacopModules.NONE} />
            <CoreDeleteButton permission="BACKOFFICE_SAMPLING_LOCATION_D" />
        </Datagrid>
    );
};



export default MobileGrid;
